// extracted by mini-css-extract-plugin
export var after = "style-module--after--e126f";
export var bottomImg = "style-module--bottom-img--9b641";
export var container = "style-module--container--4e1ee";
export var content = "style-module--content--1d4ca";
export var img = "style-module--img--9bf86";
export var imgs = "style-module--imgs--0297c";
export var left = "style-module--left--39c8a";
export var results = "style-module--results--badab";
export var right = "style-module--right--5755c";
export var topImg = "style-module--top-img--ec95b";